/**
 * Fieldset layout for forms embedded in {@link AppModal} (e.g. inline edit contact).
 * Matches slideover fieldsets: one column on narrow viewports, two from `sm` up.
 */
export const modalFormFieldsetClassName =
  "relative my-0 grid w-full min-w-0 grid-cols-1 gap-4 p-0 sm:grid-cols-2";
